'use strict'

mapButtonTemplate = require '../../map_button.html.mustache'

module.exports = Backbone.View.extend

  render: (mapHash) ->
    @$el.html(mapButtonTemplate.render(map: mapHash))